import './chat.css';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { chat, getchat } from './HttpRequest/chat';
import { userInformation } from './HttpRequest/userdetails';
import { getUserDocuments } from './HttpRequest/uploadDocuments';
import defaultProfile from "../../src/assets/img/profiles/icons8-test-account-90.png";



export default function ChatComponent({ applicationId }) {
  const [messages, setMessages] = useState([]);
  const [messageInput, setMessageInput] = useState('');

  const [ApplicationId, setApplicationId] = useState();
  const [profileImageUrl, setProfileImageUrl] = useState([defaultProfile]);

  // useEffect(()=>{

  //   if(chat){
  //     setMessageInput({
  //       ...messageInput,
  //       messageInput:chat,
  //     })
  //   }
  // },[chat])
  useEffect(() => {
    if (applicationId !== undefined) {
      console.log("id is passing-->", applicationId);
      setApplicationId(applicationId);
    }
    const fetchData = async () => {
      let page = 0;
      let size = 1000;
      const userId = sessionStorage.getItem("id") || localStorage.getItem("id");
  
      getchat(userId, ApplicationId, page, size)
      .then(async (response) => {
        console.log("applications chat response", response.data);

        const promises = response.data.map((message) => {
          return userInformation(message.userId)
            .then(async (userDetails) => {
              if (userDetails.data) {
                  const fullName = userDetails.data.firstName + userDetails.data.lastName;
                    let imageUrl;
                    if (userDetails.data.id && userDetails.data.profilePic) {
                    imageUrl = await downloadProfile(userDetails.data.id, userDetails.data.profilePic);
                    console.log("ProfileUrl==>", imageUrl);
                    return { ...message, fullName, imageUrl };
                    } else {
                     return { ...message, fullName, defaultProfile };
                    }                
              } else {
                console.error(`Invalid user details for userId ${message.userId}`);
                return message;
              }
            })
            .catch((error) => {
              console.error(`Error fetching user details for userId ${message.userId}:`, error);
              return message; // Return the original message if user details fetching fails
            });
        });

        const messages = await Promise.all(promises);
        setMessages(messages);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  };
  
    if (ApplicationId !== undefined) {
      fetchData();
    }
  }, [applicationId,ApplicationId]);
 
  const downloadProfile = async (userId, key) => {
    console.log("image download method url-->", userId, key);
    const headers = new Headers({ 'Content-Type': 'application/octet-stream' });
    const options = { headers, responseType: 'blob' };
    try {
      const response = await getUserDocuments(userId, key,options);
      console.log("Response from getUserDocuments:", response);
      if (response && response.headers && response.data) {
        const contentType = response.headers['content-type'];
        const blob = new Blob([response.data], { type: contentType });
    if (blob instanceof Blob) {
      return URL.createObjectURL(blob);
    } else {
      console.error("Invalid blob data received:", blob);
    }
  } else {
    console.error("Invalid response from getUserDocuments:", response);
    return null;
  }
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };
  





  // Function to send a user message
  const sendUserMessage = async () => {
    if (messageInput.trim() === '') return;
    // Create a new message object and add it to the messages state
    const newMessage = {
      content: messageInput,
      type: 'message-personal', // Add the necessary class for styling
      date: new Date().toISOString(), // Include a timestamp
      userId: localStorage.getItem("id"), // Add userId to the message

    };
    try {
      const userId = localStorage.getItem("id");
      const response = chat(userId, applicationId, messageInput, newMessage);
      setMessages([...messages, newMessage]);
      setMessageInput('');
      response.then((data) => {
        console.log(data);
        if (data.request.status == 200) {
          console.log("data sucess");
        } else {
          console.log("data error")
        }
      });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
    // try {
    //   const applicationId = applicationId;
    //   const userId = localStorage.getItem("id");

    //   const response = await axios.post(`http://3.6.89.206:8081/api/v1/${userId}/${applicationId}?content=${messageInput}api&type=${newMessage.type}`);
    //   setMessages([...messages, newMessage]);
    //   setMessageInput('');
    // } catch (error) {
    //   console.error('Error fetching data:', error);
    // }
    // console.log(newMessage);
    // You can add logic to send the message to a server or perform other actions here
  };

  // Function to handle user input and send the message on "Enter" key press
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      sendUserMessage();
    }
  };

  // Render the messages
  const renderMessages = () => {
    const userId = localStorage.getItem("id");
    if (!messages) {
      return null;
    }
    console.log("this is the data-->", messages)
    return messages.map((messages, index) => {
      const formattedDate = new Date(messages.date).toLocaleString();
      const messageType = userId == messages.userId ?
        "message-personal" : "message-other";
      messages.type = messageType;
      return (
        <div key={index} className={`message ${messages.type}`}>

          <div className="avatar">
            <img src={messages.imageUrl} alt="User Avatar" />
          </div>

          <div className="message-content">
            <div>{messages.content}</div>
            <div>From: {messages.fullName}</div> {/* Assuming user has a 'name' property */}
          </div>
          <div className="message-timestamp">{formattedDate}</div>
        </div>
      );
    });
  };


  return (

    <div className='gricolom'>
      <div>

        {/* <p className="application">Appliction Id: 139964/23-24</p> */}
        {/* <h6 className="blue"> <i class="fa-solid fa-book"></i> M.S. in Mechanical Engineering</h6>
    <p> <i class="fa-sharp fa-solid fa-building-columns"></i> New York Institute of Technology</p> */}
        {/* <div className="intake" style={{marginTop: '3px',}}>
      </div> */}
      </div>
      {/* <div style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}><img src='' alt='avthar' className='chatmages' /></div> */}
      <div className="avenue-messenger ">
        {/* Your chat interface structure here */}
        <div className="chat">
          <div className="messages ">
            <div className="messages-content custom-scrollbar">{renderMessages()}</div>
          </div>

        </div>
      </div>
      <div className="message-box ">
        <textarea
          type="text"
          className="message-input"

          value={messageInput}
          onChange={(e) => setMessageInput(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder='Type Message... '
        ></textarea>
        <button type="button" className="message-submit" onClick={sendUserMessage}>
          <i class="fa-solid fa-paper-plane"></i> Send
        </button>

      </div>
    </div>

  );
}
